/** PC Feed：自动 append 次数上限（不含首屏 refresh），达到后改为手动「加载更多」 */
export const FEED_PC_AUTO_APPEND_MAX = 3;

/** H5 Feed：自动 append 上限，防止 scroll 无限叠加 DOM */
export const FEED_H5_AUTO_APPEND_MAX = 8;

/** 首屏视口填充最多连续 append 次数（不含首屏 refresh；0 = 不自动补页） */
export const FEED_VIEWPORT_FILL_MAX_DEPTH = 0;

/** 过滤后可展示条数不足 pageSize 时，单次 fetch 最多连续请求的页数（探索/Sport/Crypto 等）。
 * 首页「全部」走后端 groupBySeries，不再依赖此上限凑卡。 */
export const FEED_FILTER_AUTO_PAGE_MAX = 2;

/** scroll loadMore 最小提前量（px）；实际阈值与视口高度取较大值 */
export const FEED_SCROLL_LOAD_THRESHOLD_MIN = 480;

/** H5 scroller 较矮，480px 下限会导致永远触不到触底 */
export const FEED_H5_SCROLL_LOAD_THRESHOLD_MIN = 120;

/**
 * 计算距底部多少像素内触发 loadMore。
 * @param {HTMLElement | null | undefined} container
 * @param {number} [override] 页面级固定 override（少用）
 * @param {'h5'|'pc'} [platform]
 */
export function resolveFeedScrollLoadThreshold(container, override, platform) {
  if (typeof override === 'number' && override > 0) return override;
  const viewport = Math.max(0, Number(container?.clientHeight) || 0);
  const minPx =
    platform === 'h5' ? FEED_H5_SCROLL_LOAD_THRESHOLD_MIN : FEED_SCROLL_LOAD_THRESHOLD_MIN;
  return Math.max(minPx, Math.floor(viewport * 0.85));
}
